export enum PricingPageViewProps {
  PRICING_HEADING = 'Carbon One',
  PLAN_TYPE = 'Premium annual plan',
  TIMELINE = 'From 20 Jan 2021 to 20 Jan 2022',
  PRICING_HEADING2 = 'We have more exciting plan',
  NEXT_PAYMENT = 'Your next payment is',
  PRICING_HEADING3 = 'Your payment will be automatically renewed each year',
  PRINCING_VALUE = " $7,890.00",
  CONDITION= "*condition applied",
  BTN_TEXT = "Change Plan",
}
